var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "simple-row clearfix", attrs: { name: "btns" } },
        [
          _c("div", { staticClass: "left" }, [
            _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.saveDoRel(null)
                  }
                }
              },
              [_vm._v("关联")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "deviceImpInfoTable",
          staticClass: "thin",
          staticStyle: { width: "100%", "font-size": "12px" },
          attrs: { data: _vm.devcClassifyTagSpecFieldList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "classifyTagName",
              label: "标签名称",
              width: "220",
              align: "left"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "custFieldTitle", label: "字段名称", align: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "required",
              label: "是否必填",
              width: "200",
              align: "left"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.required
                      ? _c("span", { staticClass: "font-red" }, [_vm._v("是")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              width: "200",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "left", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c("i", {
                      staticClass:
                        "icon iconfont icon-arrow-top swb-btn swb-btn-link",
                      on: {
                        click: function($event) {
                          _vm.moveUpItem(rows.row.id, true)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "icon iconfont icon-arrow-bottom swb-btn swb-btn-link",
                      on: {
                        click: function($event) {
                          _vm.moveUpItem(rows.row.id, false)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "swb-btn swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.deleteDo(rows.row.id)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07b9ef04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07b9ef04","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcCust/DevcClassifyTagSpecFieldList.vue
// module id = 2451
// module chunks = 0